<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
      ></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>User management: Create new user account</strong>
        </div>
        <div class="card-body">
          <div>
            <b-row>
              <b-col sm="1">
                <label for="roles"><strong>Security role:</strong></label><br/>
              </b-col>
              <b-col md="5" v-if="(hasRole('mdh-admin') || hasRole('mnit-admin'))">
                <b-form-select
                    id="mdhRoles"
                    setId="mdhRoles"
                    v-model="userRole"
                    :options="opts.mdhAdminRoles"
                    slug="mdhRoles"
                />
              </b-col>
              <b-col md="5" v-else-if="hasRole('org-admin')">
                <b-form-select
                    id="orgRoles"
                    setId="orgRoles"
                    v-model="userRole"
                    :options="opts.orgAdminRoles"
                    slug="orgRoles"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="1">
                <label for="firstName"><strong>First name:</strong></label><br/>
              </b-col>
              <b-col md="5">
                <b-form-input
                  id="firstName"
                  setId="firstName"
                  v-model="newUser.firstName"
                  :v="newUser.firstName"
                  slug="firstName"
                  label="firstName"
                >
                </b-form-input>
              </b-col>
            </b-row>
            <b-row cols-sm="4">
              <b-col sm="1">
                <label for="lastName"><strong>Last name:</strong></label><br/>
              </b-col>
              <b-col md="5">
                <b-form-input
                  id="lastName"
                  setId="lastName"
                  v-model="newUser.lastName"
                  :v="newUser.lastName"
                  slug="lastName"
                  label="lastName"
                >
                </b-form-input>
              </b-col>
              <b-col class="mt-auto">
                <b-button class="lg" id="searchButton" variant="secondary" @click="clear" role="button">Clear</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="1">
                <label for="lastName"><strong>Email:</strong></label><br/>
              </b-col>
              <b-col md="5">
                {{ $route.params.email }}
              </b-col>
            </b-row>
            <b-row cols="6">
              <b-col class="mt-auto">
                <b-button class="d-block p-2 bg-mdh text-white" id="searchButton" @click="createAccount" role="button">Create account</b-button>
              </b-col>
              <b-col class="mt-auto">
                <b-button class="d-block p-1 text-white" id="searchButton" @click="backButtonHandler" role="button">Back to search page</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </b-container>

</template>


<script>

import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";
import router from "@/router";
import axios from "axios";

export default {
  components: {BaseFacilitySelect},
  data: () => ({
    newUser: {
      firstName: '',
      lastName: '',
      emailAddress: '',
      org: '',
      facilities: [],
    },
    userRole: '',
    opts:{
      orgAdminRoles: [
        {value: 'org-user', text: 'Organization User'},
        {value: 'org-admin', text: 'Organization Administrator'}
      ],
      mdhAdminRoles: [
        {value: 'org-user', text: 'Organization User'},
        {value: 'org-admin', text: 'Organization Administrator'},
        {value: 'mdh-admin', text: 'MDH Administrator'},
        {value: 'mnit-admin', text: 'MNIT Administrator'},
      ]
    }

  }),

  methods: {
    clear() {
      this.newUser.firstName = ''
      this.newUser.lastName = ''
      this.users = ''
    },

    createAccount() {
      this.newUser.emailAddress = this.$route.params.email.toLowerCase().trim()
      this.newUser.facilities.push(this.$store.state.selectedFacility)
      this.newUser.org = this.$store.state.selectedFacility.org

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/user/create`, this.newUser, {params: {role: this.userRole}})
        .then(response => {
          if (response.status === 200) {
            this.showRootToast('Success','User has been created.','success')
            router.push('/userManagementSearch')
          } else {
            this.showRootToast('Error','Error creating user.','danger')
          }
        })
    },

    backButtonHandler() {
      router.push('/userManagementSearch')
    },
    hasRole(roles) {
      if (this.$keycloak.authenticated) {
        return this.$keycloak.hasResourceRole(roles);
      } else {
        return false;
      }
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },

  }
}

</script>


<style scoped>

</style>
